import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useApi } from "../../lib/api";

const href = (slug) => (slug === "despite-automobile-museum" ? "/museum" : `/entities/${slug}`);

export const Portfolio = () => {
  const { data } = useApi("/public/brands");
  return (
    <section className="max-w-7xl mx-auto px-5 md:px-8 py-12" data-testid="portfolio-section">
      <div className="eyebrow mb-3">The full portfolio</div>
      <h2 className="font-display text-3xl md:text-4xl font-bold text-ink max-w-2xl">Every business of the Despite Group.</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 mt-8">
        {(data || []).map((b) => (
          <Link key={b.slug} to={href(b.slug)} className="panel panel-hover p-4 flex items-center gap-3 group" data-testid={`portfolio-${b.slug}`}>
            {b.logo || b.banner
              ? <img src={b.logo || b.banner} alt={`${b.name}`} className={`w-12 h-12 rounded-full bg-white border border-[color:var(--line)] shrink-0 ${b.logo ? "object-contain" : "object-cover"}`} />
              : <span className="w-12 h-12 rounded-full bg-brand-green flex items-center justify-center font-display font-bold text-white shrink-0">{b.name[0]}</span>}
            <span className="min-w-0">
              <span className="block text-sm font-semibold text-ink leading-tight group-hover:text-brand-green">{b.name}</span>
              <span className="block font-data text-[10px] uppercase tracking-wider text-ink-3 mt-1">{b.kind}</span>
            </span>
            <ArrowRight size={14} className="ml-auto text-[color:var(--gold)] shrink-0 group-hover:translate-x-1 transition-transform" />
          </Link>
        ))}
      </div>
    </section>
  );
};
